import Vue from 'vue';
import { encodePathSegment } from '@/utils/url';

export default order => Vue.$http
    .delete(`Orders/${encodePathSegment(order.id)}`);



// WEBPACK FOOTER //
// ./src/services/order/del.js